import { FieldRenderProps } from 'react-final-form';

export interface ChipFieldProps extends FieldRenderProps<any, HTMLInputElement> {}

export const CHIPGUTTER = 20;
export interface ChipOwnProps {
  onChange: (value: any) => void;
  disabled?: boolean;
  input?: any;
  meta?: any;
  testId?: string;
  options: any[];
  keyProperty?: string;
  showProperty?: string;
  isMultpleSelection?: boolean;
  amountPerRow?: number;
  isValueObject?: boolean;
}

export type ChipProps = ChipFieldProps | ChipOwnProps;
